import React from "react";
const getFillColor = (color: string) => {
  return color === "currentColor" ? `currentColor` : `var(--color-${color})`;
};
const SvgXingColorIcon = ({ title, theme = null, titleId = "", ...props }) => (
  <svg
    viewBox="0 0 25 28"
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path fillRule="evenodd" clipRule="evenodd" fill={getFillColor(props.color) === "currentColor" ? `var(--color-xing-logo-green)` : getFillColor(props.color)}
      d="M1.63032 5.40491L4.91355 11.2569L0 19.8872H5.86284L10.7403 11.2569L7.45794 5.40401L1.63032 5.40491Z"/>
    <path fillRule="evenodd" clipRule="evenodd" fill={getFillColor(props.color) === "currentColor" ? `var(--color-xing-logo-lightgreen)` : getFillColor(props.color)}
      d="M19.0779 0L9.60309 16.8379L15.7125 28H21.6575L15.4433 16.8379L24.929 0H19.0779Z"/>
    </svg>
);

export interface Props {
  color?: string;
  width?: string;
  height?: string;
  title: string;
  titleId?: string;
  theme?: any;
  fill?: string;
}

const SvgXingColorStyle = ({
  color = "currentColor",
  title,
  fill,
  ...props
}: Props) => (
  <SvgXingColorIcon
    color={getFillColor(color)}
    className={color === "currentColor" ? "icon-current-color" : ""}
    {...(color !== "currentColor"
      ? { style: { color: getFillColor(color), fill: getFillColor(color) } }
      : null)}
    fill={fill ?? getFillColor(color)}
    title={title}
    {...props}
  />
);
export const XingColorIcon: any = SvgXingColorStyle;
export default XingColorIcon;
